import * as Types from '../../constants/actionTypes';
const initState = {
  addedAssets: [],
  additionalInfo: null,
  requestPacking: [],
  packingList: [],
  requestDetail: {},
  addressList: [],
  addressCollectionDetailsList: [],
  requestQuoteDetails: {},
  requestlabelsList: [],
  portalAdditionalFields: [],
  portalUserCountries: [],
  requestAddtionalFields: {},
  programAdditionalInfo: [],
  assetRequestError: [],
  trucksList: [],
  clientServiceTypeList: [],
  portalUserCompanies: [],
  addNewCompanyResponse: null,
  addNewTruckSizeResponse: null,
  countriesList: [],
  holidays: [],
  addressCollectionList: [],
  requestImported: {},
  programAssetsList: [],
  allUsersSupervisorAccessData: [],
  abisdata: [],
}
export default (state = initState, action) => {
  //console.log(`state in auth is :`,state);
  switch (action.type) {
    case Types.REQUEST_LIST_DETAILS_SUCCESS:
      let finalRequestDetail = action.payload
      if (state.requestDetail && Object.keys(state.requestDetail).length) {
        finalRequestDetail = action.payload
        const checkExistKeys = ["requestTypeInfo", "clientInfo", "portalInfo", "carrierInfo", "recyclintPartnerInfo", "clientServiceGroupInfo"]
        for (let oneKey of checkExistKeys) {
          if (state.requestDetail[oneKey] && action.payload && !action.payload[oneKey]) {
            finalRequestDetail[oneKey] = state.requestDetail[oneKey]
          }
        }
      }
      return {
        ...state,
        requestDetail: finalRequestDetail
      }
    case Types.REQUEST_TYPE_SUCCESS: {
      return {
        ...state,
        requestType: action.payload
      }
    }
    case Types.GET_REQUEST_ID: {
      return {
        ...state,
        requestId: action.payload
      }
    }
    case Types.IMPORT_EOS_REQUEST: {
      return {
        ...state,
        requestImported: action.payload
      }
    }
    case Types.GET_REQUEST_ID_ERROR: {
      return {
        ...state,
        reqIdErr: action.payload
      }
    }
    case Types.GET_ASSETS_TYPE_SUCCESS: {
      return {
        ...state,
        requestAssetsList: action.payload
      }
    }
    case Types.GET_PROGRAM_ASSETS_TYPE_SUCCESS: {
      return {
        ...state,
        programAssetsList: action.payload
      }
    }
    case Types.GET_SERVICE_GROUPS_SUCCESS: {
      return {
        ...state,
        serviceGroups: action.payload
      }
    }
    case Types.ALL_PORTAL_STATUSES: {
      return {
        ...state,
        listAllStatuses: action.data.data
      }
    }

    case Types.GET_CLIENT_SERVICE_TYPE:
      return {
        ...state,
        clientServiceTypeList: action.payload,
      }
    // case Types.UPDATED_REQUEST_SUCCESS:{
    //     return {
    //         ...state,
    //         requestStatus:action.payload
    //     }
    // } 
    case Types.GET_SERVICES_SUCCESS: {
      let tempServiceTypes = {};
      action.payload.forEach(item => {
        tempServiceTypes[item.id] = item;
      });
      return {
        ...state,
        servicesType: action.payload,
        tempServiceTypes
      }
    }
    case Types.GET_ASSETS_UNDER_REQUEST_TYPE_SUCCESS: {
      return {
        ...state,
        addedAssets: action.payload
      }
    }
    case Types.GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_SUCCESS: {
      return {
        ...state,
        addedAssetsExcel: action.payload
      }
    }
    case Types.GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_SUCCESS_ON_DIALOG: {
      return {
        ...state,
        addedAssetsExcelOnDialog: action.payload
      }
    }
    case Types.GET_ASSETS_UNDER_REQUEST_TYPE_ERROR: {
      return {
        ...state,
        assetRequestError: action.payload
      }
    }

    case Types.GET_RECYLCLEPARTNER_LIST_TYPE_SUCCESS: {
      return {
        ...state,
        recyclingPartners: action.payload
      }
    }
    case Types.SELECTED_SERVICES_SUCCESS: {
      return {
        ...state,
        selectedservicesType: action.payload
      }
    }
    case Types.ASSETS_DETAIL_SAVE_LIST: {
      return {
        ...state,
        saveAssetsList: action.payload
      }
    }
    // case Types.GET_LOGISTICS_OPTION: {
    //   return {
    //     ...state,
    //     logisticsOption: action.payload
    //   }
    // } 
    case Types.ASSETS_DETAIL_SAVE_ERROR: {
      return {
        ...state,
        assetDetailError: action.payload
      }
    }
    case Types.REQUEST_STATUSES_ERROR: {
      return {
        ...state,
        requestStatusesError: action.payload
      }
    }

    case Types.UPLOAD_ASSET_LIST_SUCCESS: {
      return {
        ...state,
        uploadedList: action.payload
      }
    }
    case Types.BULK_ASSET_UPLOAD_SUCCESS: {
      return {
        ...state,
        bulkUploadData: action.payload
      }
    }

    case Types.UPLOAD_ASSET_LIST_ERROR: {
      return {
        ...state,
        uploadedListError: action.payload
      }
    }
    case Types.SET_ADDRESS_COLLECTIONS:
      return {
        ...state,
        addressCollectionList: action.data
      }
    case Types.DELETE_ADDRESS_COLLECTION_SUCCESS:
      const { siteId } = action.payload
      return {
        ...state,
        addressCollectionList: state.addressCollectionDetailsList.filter(item => item.siteId !== siteId)
      }

    case Types.ADD_ADDRESS_COLLECTION_DETAILS_SUCCESS:
      return {
        ...state,
        responseMessage: action.payload.message,
        addressCollectionList: [...state.addressCollectionList, action.payload.data]
      }
    case Types.ADD_ADDRESS_COLLECTION_ERROR:
      return {
        ...state,
        collectionErrorMessage: action.payload
      }


    case Types.ADDRESS_COLLECTION_BY_SITE_ID_SUCCESS:
      return {
        ...state,
        addressCollectionDetailsList: action.payload
      }
    case Types.PORTAL_COLLECTION_ADDRESS_ERROR:
      return {
        ...state,
        addressError: action.addressError
      }
    case Types.UPDATED_COLLECTION_ADDRESS:
      let findExistIndex;
      if (action.updatedCollection && state.addressCollectionDetailsList && state.addressCollectionDetailsList.length) {
        findExistIndex = state.addressCollectionDetailsList && state.addressCollectionDetailsList.findIndex((oneSite) => { return oneSite.siteId === action.updatedCollection.siteId })
        if (findExistIndex >= 0) {
          state.addressCollectionDetailsList[findExistIndex] = action.updatedCollection
        }
      }
      return {
        ...state
      }
    case Types.DESTINATION_ADDRESS_SUCCESS:
      return {
        ...state,
        destinationAddress: action.payload
      }
    case Types.DELETE_SELECTED_SUCCESS:
      return {
        ...state,
        deletedAsset: action.data
      }
    case Types.UPDATE_ASSET_SUCCESS:
      return {
        ...state,
        updatedAsset: action.data
      }
    case Types.UPDATE_ASSET_ERROR:
      return {
        ...state,
        updatedAssetError: action.data
      }
    case Types.SAVE_SERVICE_SUCCESS:
      const allAddedAssets = state.addedAssets
      let selectedAssetIndex = -1
      if (action.payload) {
        selectedAssetIndex = allAddedAssets.findIndex(oneAsset => oneAsset.id === action.payload.id)
      }
      if (selectedAssetIndex >= 0) {
        const finalPayload = { ...action.payload, assetsInfo: allAddedAssets[selectedAssetIndex].assetsInfo }
        allAddedAssets[selectedAssetIndex] = finalPayload
      }
      return {
        ...state,
        addedAssets: allAddedAssets
      }

    //test for save service error
    case Types.SAVE_SERVICE_ERROR:
      return {
        ...state,
        saveServiceError: action.error
      }
    case Types.SAVED_SERVICES_UNDER_ASSET_SUCCESS:
      return {
        ...state,
        getSavedServices: action.payload
      }

    case Types.SAVED_SERVICES_UNDER_EXCEL_ASSET_SUCCESS:
      return {
        ...state,
        getExcelSavedServices: action.payload
      }

    //for asset excel
    case Types.EXCEL_ASSET_SUCCESS:
      return {
        ...state,
        getAssetExcel: action.payload
      }
    case Types.EXCEL_ASSET_ERROR:
      return {
        ...state,
        getAssetExcelError: action.error
      }
    case Types.EXCEL_AVAILABLE_SUCCESS:
      return {
        ...state,
        isExcelAvailable: action.payload
      }
    case Types.EXCEL_AVAILABLE_ERROR:
      return {
        ...state,
        excelAvailableError: action.error
      }
    case Types.GET_PACKING_PORTAL_LIST:
      return {
        ...state,
        packingList: action.payload
      }
    case Types.ADD_REQUEST_PACKING_SUCCESS:

      if (action.payload) {
        const checkIfAnyExistPackIndex = state.requestPacking.findIndex(onePack => { return onePack.size === action.payload.size })
        if (checkIfAnyExistPackIndex >= 0) {
          state.requestPacking[checkIfAnyExistPackIndex] = action.payload
        } else {
          state.requestPacking.push(action.payload)
        }
      }
      return {
        ...state
      }
    case Types.GET_REQUEST_PACKING:
      return {
        ...state,
        requestPacking: action.payload
      }
    case Types.DELETE_REQUEST_PACKING:
      state.requestPacking.splice(action.delIndex, 1)
      return {
        ...state
      }
    case Types.GET_BOXES_LIST:
      return {
        ...state,
        boxesList: action.payload
      }
    case Types.BOX_OR_PACK_ERROR:
      return {
        ...state,
        boxOrPackError: action.payload
      }
    case Types.PACKAGING_DETAIL_SUCCESS:
      return {
        ...state,
        packagingData: action.payload
      }
    case Types.DIMENSIONS_LIST:
      return {
        ...state,
        dimensionsList: action.dimensionsList
      }
    case Types.DIMENSIONS_ERROR:
      return {
        ...state,
        dimensionsError: action.dimensionsError
      }
    // Program Request Stages
    case Types.PROGRAM_REQUEST_STAGES:
      return {
        ...state,
        programRequestStages: action.programRequestStages
      }
    case Types.PROGRAM_STAGE_ERROR:
      return {
        ...state,
        programStageError: action.programStageError
      }
    case Types.CLIENT_SERVICES_SUCCESS:
      return {
        ...state,
        clientServices: action.payload
      }
    case Types.EXTRA_SERVICES_INFORMATION:
      return {
        ...state,
        extraServices: action.extraServices
      }
    case Types.PACKING_SERVICES_INFORMATION:
      return {
        ...state,
        packingServices: action.packingServices
      }
    case Types.PORTAL_PACKING_GRADES:
      return {
        ...state,
        packingGrades: action.packingGrades
      }
    case Types.GET_REQUEST_SERVICE:
      return {
        ...state,
        addedRequestService: action.payload
      }
    case Types.SAVE_REQUEST_SERVICE: {
      return {
        ...state,
        savedRequestServices: action.payload
      }
    }
    case Types.REQUEST_TYPE_INPUT_FIELDS:
      return {
        ...state,
        portalRequestInputFields: action.portalRequestInputFields
      }
    case Types.GET_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        additionalInfo: action.payload
      }
    case Types.RESET_ADDITIONAL_INFO_DATA:
      return {
        ...state,
        additionalInfo: null
      }

    case Types.SAVE_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        additionalInfo: action.payload
      }

    /* Status Data Inforamation */
    case Types.PORTAL_REQUEST_STATUS_LIST:
      return {
        ...state,
        portalRequestStatusList: action.portalRequestStatusList
      }
    case Types.PROGRAM_STAGE_STATUS_LIST:
      return {
        ...state,
        portalStageStatusList: action.portalStageStatusList
      }
    case Types.REQUEST_STATUSES_PROGRESS: {
      return {
        ...state,
        requestStatusProgress: action.requestStatusProgress
      }
    }
    case Types.SELECTED_REQUEST_STATUS_SEQUENCE: {
      return {
        ...state,
        selectedStatusSequence: action.selectedStatusSequence
      }
    }
    case Types.SET_REQUEST_REJECTED: {
      return {
        ...state,
        isRequestRejected: action.isRequestRejected
      }
    }
    case Types.REQUEST_ERROR:
      return {
        ...state,
        requestError: action.payload
      }
    case Types.GET_ADDRESS_LIST:
      return {
        ...state,
        addressList: action.addressList
      }
    case Types.ADD_ADDRESS_COLLECTION_SUCCESS:
      return {
        ...state,
        addressList: action.addressList
      }

    case Types.NEW_ADDRESS_ADDED:
      state.addressList.push(action.addressAdded)
      return {
        ...state,
      }
    case Types.COUNTRIES_DETAIL_SUCCESS:
      return {
        ...state,
        countriesList: action.payload
      }
    case Types.TRUCK_DETAIL_SUCCESS:
      return {
        ...state,
        trucksList: action.payload,
        addNewTruckSizeResponse: action.payload
      }
    case Types.TRUCKS_ADDED_SUCCESS:
      state.trucksList.push(action.payload)
      return {
        ...state,
        addNewTruckSizeResponse: action.payload
      }
    case Types.TRUCK_ERROR:
      return {
        ...state,
        trucksList: action.payload,
        addNewTruckSizeResponse: action.payload
      }
    case Types.SET_ADD_NEW_TRUCK_SIZE_RESPONSE:
      return {
        ...state,
        addNewTruckSizeResponse: action.payload
      }
    case Types.REQUEST_QUOTE_INFO:
      return {
        ...state,
        requestQuoteDetails: action.payload
      }
    case Types.GET_LABEL_LIST:
      return {
        ...state,
        labelsList: action.payload
      }
    case Types.GET_REQUEST_LABEL:
      return {
        ...state,
        requestlabelsList: action.payload
      }

    case Types.ADD_REQUEST_LABEL_SUCCESS:
      state.requestlabelsList.push(action.payload)
      return {
        ...state,
      }
    case Types.DELETE_REQUEST_LABEL:
      state.requestlabelsList.splice(action.delIndex, 1)
      return {
        ...state
      }
    case Types.LABEL_ERROR:
      return {
        ...state,
        labelerror: action.payload
      }
    case Types.REQUEST_MAIL_ERROR:
      return {
        ...state,
        mailSendError: action.requestMailError
      }
    case Types.MAIL_SEND_SUCCESS:
      return {
        ...state,
        mailSend: action.payload
      }
    case Types.PORTAL_ADDITIONAL_FIELD_DATA:
      return {
        ...state,
        portalAdditionalFields: action.portalAdditionalFields
      }
    case Types.REQUEST_ADDITIONAL_FIELD_DATA:
      return {
        ...state,
        requestAddtionalFields: action.requestAddtionalFields
      }
    case Types.PORTAL_ADDITIONAL_FIELD_ERROR:
      return {
        ...state,
        portalAddFieldsError: action.portalAddFieldsError
      }
    case Types.PORTAL_USER_COUNTRIES_LIST:
      return {
        ...state,
        portalUserCountries: action.payload
      }
    case Types.ALL_PORTAL_USER_COUNTRIES_LIST:
      return {
        ...state,
        allPortalUserCountries: action.payload
      }
    case Types.PORTAL_USER_COUNTRIES_ADDED_SUCCESS:
      return {
        ...state,
        addedPortalUserCountry: action.payload
      }
    case Types.DELETED_USER_COUNTRY:
      const copyPortalUserCountries = Object.assign([], state.portalUserCountries);
      copyPortalUserCountries.splice(action.deletedUserCountryIndex, 1);
      return {
        ...state,
        portalUserCountries: copyPortalUserCountries
      }
    case Types.PORTAL_USER_COUNTRIES_LIST_ERROR:
      return {
        ...state,
        countryError: action.countryError
      }
    case Types.GET_ADDITIONAL_INFO: {
      return {
        ...state,
        programAdditionalInfo: action.payload
      }
    }
    case Types.BULK_UPLOAD_COLLECTION_SITES:
      return {
        ...state,
        addressCollectionList: [...state.addressCollectionList, ...action.payload]
      }
    case Types.ADD_PORTAL_USER_COMPANIES:
      const { data, ...message } = action.payload;
      return {
        ...state,
        portalUserCompanies: [...state.portalUserCompanies, data],
        addNewCompanyResponse: message
      }
    case Types.FETCH_PORTAL_USER_COMPANIES:
      return {
        ...state,
        portalUserCompanies: action.payload
      }
    case Types.PROGRAM_COMPANY_LIST:
      return {
        ...state,
        programCompanyList: action.payload
      }
    case Types.ADD_NEW_COMPANY_ERROR:
      return {
        ...state,
        addNewCompanyResponse: action.payload
      }
    case Types.SET_ADD_NEW_COMPANY_RESPONSE:
      return {
        ...state,
        addNewCompanyResponse: action.payload
      }
    case Types.GET_ALL_PROGRAM_LANGUAGES_SUCCESS:
      return {
        ...state,
        allProgramLanguages: action.allProgramLanguages
      }
    case Types.PROGRAM_LANGUAGES_ERROR:
      return {
        ...state,
        programLanguagesError: action.programLanguagesError
      }
    case Types.ADD_PROGRAM_COMPANY:
      return {
        ...state,
        addProgramCompany: action.addProgramCompany
      }
    case Types.HOLIDAY_FETCHED:
      return {
        ...state,
        holidays: action.payload
      }
    case Types.SET_BULK_UPLOAD_ASSET_DATA_SUCCESS:
      return {
        ...state,
        bulkUploadAssetData: action.payload
      }
    case Types.PROGRAM_PALLET_SUCCESS:
      return {
        ...state,
        programPallet: action.payload
      }
    case Types.REQUEST_PALLET_SUCCESS:
      return {
        ...state,
        requestPallet: action.payload
      }
    case Types.PROGRAM_PALLET_ERROR:
      return {
        ...state,
        programPalletError: action.payload
      }
    case Types.LIST_ALL_SUPERVISOR_USER_ACCESS:
      return {
        ...state,
        allUsersSupervisorAccessData: action.allUsersSupervisorAccessData
      }
    case Types.ABIS_DATA:
      return {
        ...state,
        abisdata: action.data
      }
    default:
      return state;
  }
};

